// src/components/CoreAssure/Readiness/ReadinessScoreCard.js
//
// CoreAssure ReadyCore — score display card.
// Big number, color-coded green/amber/red, with timestamp + computed-at.

import React from "react";
import { Card, CardContent, Stack, Typography, Box } from "@mui/material";
import { READINESS_COLOR_PALETTE, colorForScore } from "../../../utils/coreassure/readinessApi";

export default function ReadinessScoreCard({ score }) {
  if (!score || typeof score.score !== "number") return null;

  const color = score.color || colorForScore(score.score);
  const palette = READINESS_COLOR_PALETTE[color] || READINESS_COLOR_PALETTE.AMBER;

  let computedDisplay = "";
  try {
    computedDisplay = score.computedAt
      ? new Date(score.computedAt).toLocaleString()
      : "";
  } catch (_) { computedDisplay = score.computedAt || ""; }

  const blockerCount = Array.isArray(score.blockers) ? score.blockers.length : 0;

  return (
    <Card sx={{
      bgcolor: palette.bg,
      border: `2px solid ${palette.border}`,
      height: "100%",
    }}>
      <CardContent>
        <Stack spacing={1} alignItems="center">
          <Typography variant="caption" sx={{ color: palette.fg, letterSpacing: 0.5, fontWeight: 700 }}>
            READYCORE SCORE
          </Typography>
          <Box sx={{
            fontSize: 64,
            fontWeight: 800,
            lineHeight: 1,
            color: palette.fg,
          }}>
            {score.score}<span style={{ fontSize: 32 }}>%</span>
          </Box>
          <Typography variant="body2" sx={{ color: palette.fg, fontWeight: 600 }}>
            {color}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {score.jobName || `Job #${score.jobId}`}
          </Typography>
          {blockerCount > 0 && (
            <Typography variant="caption" sx={{ color: palette.fg }}>
              {blockerCount} blocker{blockerCount === 1 ? "" : "s"} to clear
            </Typography>
          )}
          {computedDisplay && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
              Computed {computedDisplay}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
